<label *ngIf="label !== ''"
    >{{ label }}<span *ngIf="required" class="color-weak"> *</span></label
>
<div
    *ngIf="control.invalid && (control.dirty || control.touched)"
    class="input-error"
>
    <rr-icon name="octagon"></rr-icon>
    <span *ngIf="control.hasError('required')" i18n
        >This field is required</span
    >
    <span *ngIf="!control.hasError('required')" i18n
        >Your input is not valid</span
    >
</div>
<div
    class="mainselect disabled-{{ disabled }} {{ errorClass }}"
    (click)="toggleOptions($event.target)"
    (blur)="onTouched()"
    tabindex="0"
>
    <span class="selecttext">
        <img
            [src]="selectedIcon"
            *ngIf="selectedIcon !== '' && iconType == 'image'"
            alt=""
        />
        <rr-icon
            *ngIf="selectedIcon !== '' && iconType == 'icon'"
            [name]="selectedIcon"
        ></rr-icon>
        {{ selectedName }}
    </span>
    <rr-icon name="chevron-down"></rr-icon>
</div>

<!-- Dropdown -->
<div class="backdrop" (click)="onBackdropClick()" *ngIf="showOptions"></div>
<div
    class="selectoptions {{ errorClass }}"
    *ngIf="showOptions"
    [style.width]="elementWidth"
    [style.marginTop]="elementHeight"
>
    <div
        class="selectoption"
        *ngFor="let option of options"
        (click)="selectOption(option)"
    >
        <rr-icon
            *ngIf="option?.icon && iconType == 'icon'"
            [name]="option.icon"
        ></rr-icon>
        <img
            [src]="option.icon"
            *ngIf="option?.icon && iconType == 'image'"
            alt=""
        />
        {{ option[optionName] }}
    </div>
</div>
